import type { CurrencyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';

/** Валюты плательщика: справочник компаний + текущая валюта заявки, если её нет в списке организации. */
export const resolveOrganizationCurrencies = (
  organization: CompanyFindInterface | null | undefined,
  organizations: CompanyFindInterface[] = [],
  currentCurrency?: CurrencyFindInterface | null
): CurrencyFindInterface[] => {
  const organizationId = organization?.id;
  if (!organizationId) {
    return [];
  }

  const organizationFromDirectory = organizations.find(({ id }) => id === organizationId);
  const organizationCurrencies = organizationFromDirectory?.currencies?.length
    ? organizationFromDirectory.currencies
    : organization?.currencies;

  if (!organizationCurrencies?.length) {
    return currentCurrency ? [currentCurrency] : [];
  }

  const currencies = [...organizationCurrencies];
  if (currentCurrency?.id && !currencies.some(({ id }) => id === currentCurrency.id)) {
    currencies.push(currentCurrency);
  }

  return currencies;
};
